import React, { Component } from 'react';
import ReactExport from 'react-data-export';
import { Button } from '@progress/kendo-react-buttons';
import moment from 'moment';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

class RMAllocationExcel extends Component {
    constructor(props) {
        super(props);

        this.state = {
            rmAllocationGrid: null,
            nullData: [{ columns: [], data: [] }],
        };
    }

    componentDidMount() {
        if (this.props.updateData === true) {
            this.populateRMAllocationData();
        }
    }

    componentDidUpdate = async() => {
        if (this.props.updateData === true) {
            this.props.dataUpdated();
            await this.populateRMAllocationData();
            document.getElementById("rmAllocationReport").click();
        }
    }

    populateRMAllocationData = async() => {
        let allocationRows = [];
        const borderStyle = {
            border: {
                top: { style: "thin", color: "000000" },
                right: { style: "thin", color: "000000" },
                bottom: { style: "thin", color: "000000" },
                left: { style: "thin", color: "000000" }
            }
        };

        if (this.props.rmAllocationData && this.props.rmAllocationData.length > 0) { 
            for (const record of this.props.rmAllocationData) {
                allocationRows.push([
                    {
                        value: record.ResourceId != null ? record.ResourceId : '',
                        style: borderStyle
                    },
                    {
                        value: record.ResourceName ? record.ResourceName : '',
                        style: borderStyle
                    },
                    {
                        value: record.ProjectRole ? record.ProjectRole : '',
                        style: borderStyle
                    },
                    {
                        value: record.ResourceDepartment != null ? record.ResourceDepartment : '',
                        style: borderStyle
                    },
                    {
                        value: record.ResourcePractice != null ? record.ResourcePractice : '',
                        style: borderStyle
                    },
                    {
                        value: record.ProjectCode ? record.ProjectCode : '',
                        style: borderStyle
                    },
                    {
                        value: record.ProjectName ? record.ProjectName : '',
                        style: borderStyle
                    },
                    {
                        value: record.ProjectStatus ? record.ProjectStatus : '',
                        style: borderStyle
                    },
                    {
                        value: record.StartDate ? moment(record.StartDate).format('YYYY-MM-DD') : '',
                        style: borderStyle
                    },
                    {
                        value: record.EndDate ? moment(record.EndDate).format('YYYY-MM-DD') : '',
                        style: borderStyle
                    },
                    {
                        value: record.TotalAllocationPercentage != null ? Number(record.TotalAllocationPercentage) : 0,
                        style: borderStyle
                    },
                    {
                        value: record.BillablePercentage != null ? Number(record.BillablePercentage) : 0,
                        style: borderStyle
                    },
                    {
                        value: record.NonBillablePercentage != null ? Number(record.NonBillablePercentage) : 0,
                        style: borderStyle
                    },
                    {
                        value: record.PreSalesPercentage != null ? Number(record.PreSalesPercentage) : 0,
                        style: borderStyle
                    },
                    {
                        value: record.SoftBookingPercentage != null ? Number(record.SoftBookingPercentage) : 0,
                        style: borderStyle
                    },
                    {
                        value: record.BillableTimeSum != null ? Number(record.BillableTimeSum) : 0,
                        style: borderStyle
                    },
                    {
                        value: record.NonBillableTimeSum != null ? Number(record.NonBillableTimeSum) : 0,
                        style: borderStyle
                    },
                    {
                        value: record.PreSalesTimeSum != null ? Number(record.PreSalesTimeSum) : 0,
                        style: borderStyle
                    },
                    {
                        value: record.PendingApprovalTimeSum != null ? Number(record.PendingApprovalTimeSum) : 0,
                        style: borderStyle
                    },
                    {
                        value: record.AllocationType ? record.AllocationType : '',
                        style: borderStyle
                    },
                    {
                        value: record.Billability ? record.Billability : '',
                        style: borderStyle
                    }
                ]);
            }

            let headerColumns = [
                { value: 'Resource Id',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Resource',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Project Role',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Department',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Practice',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Project Id',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Project',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Project Status',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Start Date',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'End Date',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Total Planned Percentage',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Billable Allocation %',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Non-Billable Allocation %',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Presales Allocation %',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'SoftBooking Allocation %',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Total Billable Approved Hours',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Total Non-Billable Approved Hours',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Total Presales Tasks Approved Hours',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Total Pending Approval Hours',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Allocation Type',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Billability',  style: {font: { bold: true }, border: borderStyle.border}},
            ];

            let emptyRow = [];
            for (const row of headerColumns) {
                if (row.value === 'Project Role' || row.value === 'Project') {
                    let record = { title: '', width: { wpx: 250 } }
                    emptyRow.push(record);   
                } else {
                    let record = { title: '', width: { wpx: 120 } }
                    emptyRow.push(record);   
                }
            }

            const endDateStr = this.props.endDateFilter ? moment(this.props.endDateFilter).format('YYYY-MM-DD') : '';

            const rmAllocationGrid = [
                {
                    columns: [
                        {title: `Allocation History List - Allocation End Date >= ${endDateStr}`, width: {wpx: 250}},
                        {title: '', width: {wpx: 150}},
                    ],
                    data: []
                },
                {
                    columns: emptyRow,
                    data: [headerColumns, ...allocationRows]
                }
            ];
    
            await this.setState({
                rmAllocationGrid: rmAllocationGrid
            });
        }
    }

    render() {
        return (
            <ExcelFile
                filename={'Allocation History List - ' + moment(new Date()).format('DD-MMM-YYYY')}
                element={ 
                    <Button id={"rmAllocationReport"} className="d-none">
                        {''}
                    </Button>
                }
            >
                <ExcelSheet
                    dataSet={this.state.rmAllocationGrid ? this.state.rmAllocationGrid : this.state.nullData}
                    name="Allocation History List"
                />
            </ExcelFile>
        );
    }
}

export default RMAllocationExcel;
